// Apolo IDE — recentRepos (sprint composer-anchor E5).
//
// Lista de repos recém-usados pro RepoPickerPill (recognition > recall, NN/g).
// PERSISTE (diferente do github_repo selecionado, que é efêmero): uma LISTA de
// recentes pra re-escolher rápido NÃO é o bug do default grudado — é o oposto,
// reconhecimento. Cap 5, dedupe por full_name, mais recente primeiro.

const KEY = 'apolo:code:recentRepos';
const CAP = 5;

function safeParse(raw) {
  try {
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}

/** @returns {Array<{name?:string, full_name:string, url?:string, clone_url?:string, default_branch?:string, private?:boolean}>} */
export function getRecentRepos() {
  if (typeof window === 'undefined' || !window.localStorage) return [];
  const list = safeParse(window.localStorage.getItem(KEY) || '[]');
  return list.filter((r) => r && typeof r.full_name === 'string').slice(0, CAP);
}

/**
 * Empurra um repo pro topo dos recentes (dedupe por full_name, cap 5).
 * @returns {Array} a nova lista (também persistida)
 */
export function pushRecentRepo(repo) {
  if (!repo || typeof repo.full_name !== 'string') return getRecentRepos();
  const entry = {
    name: repo.name,
    full_name: repo.full_name,
    url: repo.url,
    clone_url: repo.clone_url,
    default_branch: repo.default_branch || 'main',
    private: !!repo.private,
  };
  const prev = getRecentRepos().filter((r) => r.full_name !== entry.full_name);
  const next = [entry, ...prev].slice(0, CAP);
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
      /* quota/private — recentes só não persistem */
    }
  }
  return next;
}
